import { useAuthenticator } from "@aws-amplify/ui-react";
import { usePostHog } from "posthog-js/react";
import { useEffect, useRef } from "react";
import { AUTH_ROUTE_TO_EVENT } from "../data/auth-events";

const AuthRouteTracker = () => {
  const { route } = useAuthenticator();
  const posthog = usePostHog();
  const previousRouteRef = useRef<string | null>(null);

  useEffect(() => {
    if (route && route !== previousRouteRef.current) {
      const eventName = AUTH_ROUTE_TO_EVENT[route];
      if (eventName && posthog) {
        posthog.capture(eventName);
      }
      previousRouteRef.current = route;
    }
  }, [route, posthog]);

  return null;
};

export default AuthRouteTracker;
